




























import { Component, Vue } from "vue-property-decorator";

@Component
export default class UnsavedFormModal extends Vue {
    open() {
        this.$bvModal.show("modal-navigateFromUnsavedForm");
    }

    decline() {
        this.$emit("continue", false);
        this.$bvModal.hide("modal-navigateFromUnsavedForm");
    }

    confirm() {
        this.$emit("continue", true);
        this.$bvModal.hide("modal-navigateFromUnsavedForm");
    }
}
